const SKELETON = {
  car_rental: () => ({ pickup: {}, dropoff: {}, vehicle: {}, driver: {} }),
  flight: () => ({
    origin: {},
    destination: {},
    passengers: {},
    tripType: 'one_way',
  }),
  hotel: () => ({ guests: {} }),
  package: () => ({ components: [] }),
  other: () => ({}),
};

export const emptyDetails = type => (SKELETON[type] || SKELETON.other)();

const REQUIRED_PATHS = {
  car_rental: ['pickup.locationName', 'pickup.at', 'dropoff.at'],
  flight: ['origin.locationCode', 'destination.locationCode', 'departureAt'],
  hotel: ['hotelName', 'checkIn', 'checkOut'],
  other: [],
};

const readPath = (object, path) =>
  path.split('.').reduce((value, key) => (value || {})[key], object);

const isBlank = value => value === undefined || value === null || value === '';

export const missingPaths = (type, details = {}) => {
  if (type === 'package') {
    const components = details.components || [];
    if (!components.length) return ['components'];
    return components.flatMap((component, index) =>
      missingPaths(component.type, component).map(
        path => `components.${index}.${path}`
      )
    );
  }
  return (REQUIRED_PATHS[type] || []).filter(path =>
    isBlank(readPath(details, path))
  );
};
